var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeGeminni15Pro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8571 0.5C33.4224 0.5 35.5 2.57757 35.5 5.14286V30.8571C35.5 33.4224 33.4224 35.5 30.8571 35.5H5.14286C2.57757 35.5 0.5 33.4224 0.5 30.8571V5.14286C0.5 2.57757 2.57757 0.5 5.14286 0.5H30.8571Z",
    fill: "white",
    stroke: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19423_52760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9021 18.0979C24.2853 18.0979 18.0979 24.2853 18.0979 31.9021C18.0979 31.9608 18.0587 32 18 32C17.9413 32 17.9021 31.9608 17.9021 31.9021C17.9021 24.2853 11.7147 18.0979 4.0979 18.0979C4.03916 18.0979 4 18.0587 4 18C4 17.9413 4.03916 17.9021 4.0979 17.9021C11.7147 17.9021 17.9021 11.7147 17.9021 4.0979C17.9021 4.03916 17.9413 4 18 4C18.0587 4 18.0979 4.03916 18.0979 4.0979C18.0979 11.7147 24.2853 17.9021 31.9021 17.9021C31.9608 17.9021 32 17.9413 32 18C32 18.0587 31.9608 18.0979 31.9021 18.0979Z",
    fill: "url(#paint0_linear_19423_52760)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19423_52760",
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D71BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9CDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19423_52760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeGeminni15Pro);
export default __webpack_public_path__ + "static/media/type=Geminni 1.5 Pro.8ac5f95eea0d8b016185cddf1d9d1474.svg";
export { ForwardRef as ReactComponent };